function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useState } from 'react';
import { ScrollBarContainer } from '../../atoms/ScrollBarContainer/ScrollBarContainer';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import { Text } from '../../atoms/Text';
import { InavigateLeft } from '../../atoms/AgroIcon/icons';
import { Box } from '../../atoms/Box';
import styled, { css, keyframes } from 'styled-components';
import ItemList from './ItemList';
import { MobileMenuV2 } from '../MobileMenuV2/MobileMenuV2';
var MenuSlideFull = function MenuSlideFull(_ref) {
  var title = _ref.title,
    linkText = _ref.linkText,
    URL = _ref.URL,
    items = _ref.items,
    next = _ref.next,
    back = _ref.back,
    notifications = _ref.notifications,
    tagManager = _ref.tagManager,
    level2 = _ref.level2;
  var _useContext = useContext(AgroHeaderContext),
    user = _useContext.user,
    level = _useContext.level,
    setLevel = _useContext.setLevel,
    variant = _useContext.variant,
    accountMenu = _useContext.accountMenu,
    sessionItem = _useContext.sessionItem;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    moving = _useState2[0],
    setMoving = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isFirstOpen = _useState4[0],
    setIsFirstOpen = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    text = _useState6[0],
    setText = _useState6[1];
  var itemsMap = _toConsumableArray(items);
  var handleBack = function handleBack() {
    var newText = _toConsumableArray(text).pop();
    setText(newText);
    setLevel(function (prevLevel) {
      return prevLevel - 1;
    });
    setMoving(true);
    back();

    // Handle animation
    setTimeout(function () {
      setMoving(false);
    }, 1);
  };
  var handleNext = function handleNext(event, item) {
    if (!item.URL && !item.Children) {
      event.preventDefault();
      return;
    }
    if (item.Children && item.Children.length === 0) {
      handleClickTrackEvent(item.Name);
      setMoving(true);
      return;
    }
    setIsFirstOpen(false);
    setMoving(true);
    if (item.Children) {
      setText([].concat(_toConsumableArray(text), [item.Name]));
      setLevel(function (prevLevel) {
        return prevLevel + 1;
      });
      next(event, item);
      setTimeout(function () {
        setMoving(false);
      }, 1);
    } else {
      if (level === 1) {
        handleClickTrackEvent(item.Name);
      }
      next(event, item);
    }
  };
  var handleClickTrackEvent = function handleClickTrackEvent(t) {
    var eventLabel = text.length ? [text, t].join(' - ') : t;
    if (tagManager) {
      var tagMangagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'Navigation',
          eventAction: 'Agrofy News-Menu Header',
          eventLaber: "Mobile_".concat(eventLabel)
        }
      };
      tagManager(tagMangagerArgs);
    }
  };
  var hasNotifications = function hasNotifications(item) {
    var conditions = [{
      url: '/myaccount/#/received',
      hasNotif: notifications.ReceivedUnread ? notifications.ReceivedUnread.count > 0 : false
    }, {
      url: '/myaccount/#/quotations/received',
      hasNotif: notifications['SELLER_PENDINGRESPONSE'] ? notifications['SELLER_PENDINGRESPONSE'].count > 0 : false
    }, {
      url: '/myaccount/#/sent',
      hasNotif: notifications.Sent ? notifications.Sent.count > 0 : false
    }, {
      url: '/myaccount/#/quotations/sent',
      hasNotif: notifications['BUYER_PENDINGACCEPTANCE'] ? notifications['BUYER_PENDINGACCEPTANCE'].count > 0 : false
    }];
    var found = conditions.find(function (cond) {
      return cond.url === item.URL && cond.hasNotif;
    });
    return found ? /*#__PURE__*/React.createElement(Notification, null) : null;
  };
  return moving ? null : /*#__PURE__*/React.createElement(MenuSlideContainer, {
    as: "ul",
    isFirstOpen: isFirstOpen
  }, title && title !== '' ? /*#__PURE__*/React.createElement(StyledTitleItem, null, /*#__PURE__*/React.createElement(StyledBoxTitle, null, /*#__PURE__*/React.createElement(InavigateLeft, {
    fill: "gray900",
    onClick: handleBack
  })), /*#__PURE__*/React.createElement(StyledBoxTitle, null, /*#__PURE__*/React.createElement(Text, {
    className: "label",
    type: "heading-xs",
    mr: "md",
    color: "gray900"
  }, title))) : '', level === 0 && user && variant === 'full' && accountMenu && /*#__PURE__*/React.createElement(StyledMyAccountContainer, null, /*#__PURE__*/React.createElement(ItemList, {
    item: accountMenu,
    index: 100,
    handleNext: handleNext,
    hasNotifications: hasNotifications,
    level: level,
    notifications: notifications,
    title: title
  })), itemsMap === null || itemsMap === void 0 ? void 0 : itemsMap.map(function (itemS, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "".concat(itemS.title, "-").concat(index)
    }, itemS.items.map(function (item, idx) {
      return /*#__PURE__*/React.createElement(ItemList, {
        key: "items-".concat(idx, "-").concat(item.ID),
        item: item,
        index: idx,
        handleNext: handleNext,
        hasNotifications: hasNotifications,
        level: level,
        notifications: notifications,
        title: title,
        onMouseDown: function onMouseDown() {
          return handleClickTrackEvent(item.Name);
        }
      });
    }), itemsMap.length - 1 !== index && /*#__PURE__*/React.createElement(StyledLineSeparator, null));
  }), user && level === 0 && sessionItem && /*#__PURE__*/React.createElement(StyledSessionBox, null, /*#__PURE__*/React.createElement(StyledItemList, {
    item: sessionItem,
    index: 101,
    handleNext: handleNext,
    hasNotifications: hasNotifications,
    level: level,
    notifications: notifications,
    title: title
  })));
};
var MenuSlideContainer = styled(Box).withConfig({
  displayName: "MenuSlideFull__MenuSlideContainer",
  componentId: "sc-1ddten9-0"
})(["box-sizing:border-box;display:flex;flex-direction:column;list-style:none;margin:0;padding:0;overflow-y:scroll;padding-bottom:120px;overflow:auto;width:100%;height:100%;animation:", ";background-color:", ";border-top:2px solid ", ";@media (min-width:", "){display:none;}"], function (props) {
  return !props.isFirstOpen ? css(["", " 0.2s"], slide) : '';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray500;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoint.lg;
});
var StyledMyAccountContainer = styled.div.withConfig({
  displayName: "MenuSlideFull__StyledMyAccountContainer",
  componentId: "sc-1ddten9-1"
})(["margin-top:16px;"]);
var StyledSessionBox = styled(Box).withConfig({
  displayName: "MenuSlideFull__StyledSessionBox",
  componentId: "sc-1ddten9-2"
})(["height:auto;display:flex;align-items:flex-start;> li{width:100%;}"]);
var StyledItemList = styled(ItemList).withConfig({
  displayName: "MenuSlideFull__StyledItemList",
  componentId: "sc-1ddten9-3"
})(["padding:12px 0px 12px 16px;"]);
var StyledTitleItem = styled.li.withConfig({
  displayName: "MenuSlideFull__StyledTitleItem",
  componentId: "sc-1ddten9-4"
})(["display:flex;padding:16px;align-items:center;background-color:", ";box-sizing:border-box;border-bottom:1px ", " solid;height:56px;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray200;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.gray500;
});
var StyledBoxTitle = styled(Box).withConfig({
  displayName: "MenuSlideFull__StyledBoxTitle",
  componentId: "sc-1ddten9-5"
})(["width:40%;"]);
var StyledItem = styled.li.withConfig({
  displayName: "MenuSlideFull__StyledItem",
  componentId: "sc-1ddten9-6"
})(["display:flex;padding:12px 16px 10px 16px;align-items:center;gap:16px;align-self:stretch;"]);
var StyledLineSeparator = styled.div.withConfig({
  displayName: "MenuSlideFull__StyledLineSeparator",
  componentId: "sc-1ddten9-7"
})(["border-bottom:1px solid ", ";margin:8px;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.gray400;
});
var StyledTitleSection = styled(Text).withConfig({
  displayName: "MenuSlideFull__StyledTitleSection",
  componentId: "sc-1ddten9-8"
})(["color:", ";text-transform:uppercase;font-size:12px;font-weight:600;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.gray700;
});
var slide = keyframes(["0%{transform:translate(-100%);}100%{transform:translate(0px);}"]);
export { MenuSlideFull };